import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FaStar } from "react-icons/fa";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css/navigation";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

export default function Testimonials() {
    const reviews = [
        {
            name: "Ahmed Khan",
            role: "Traveler",
            image: "https://randomuser.me/api/portraits/men/32.jpg",
            review:
                "Amazing experience! The booking was smooth and the hotel exceeded expectations. Highly recommended!",
        },
        {
            name: "Sara Ali",
            role: "Tourist",
            image: "https://randomuser.me/api/portraits/women/44.jpg",
            review:
                "Best travel platform I’ve used. Great deals and excellent customer support!",
        },
        {
            name: "John Smith",
            role: "Business Traveler",
            image: "https://randomuser.me/api/portraits/men/12.jpg",
            review:
                "Very professional service. I always find the best hotels here for my business trips.",
        },
        {
            name: "Ali Raza",
            role: "Explorer",
            image: "https://randomuser.me/api/portraits/men/55.jpg",
            review:
                "Super easy booking process and great hotel recommendations. Loved it!",
        },
    ];

    return (
        <section className="bg-gray-50 py-12 sm:py-16 lg:py-20">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

                {/* Heading */}
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-3">
                    What Our Customers Say
                </h2>

                <p className="text-sm sm:text-base text-gray-500 mb-10 sm:mb-12">
                    Real experiences from our happy travelers
                </p>

                {/* Navigation Buttons */}
                <div className="flex justify-center sm:justify-end gap-3 mb-6">
                    <button className="custom-prev bg-white shadow p-2 sm:p-3 rounded-full hover:bg-gray-100 transition">
                        <FaArrowLeft className="text-sm sm:text-base" />
                    </button>

                    <button className="custom-next bg-white shadow p-2 sm:p-3 rounded-full hover:bg-gray-100 transition">
                        <FaArrowRight className="text-sm sm:text-base" />
                    </button>
                </div>

                {/* Swiper */}
                <Swiper
                    modules={[Autoplay, Pagination, Navigation]}
                    spaceBetween={16}
                    slidesPerView={1}
                    loop={true}
                    loopFillGroupWithBlank={true}
                    navigation={{
                        nextEl: ".custom-next",
                        prevEl: ".custom-prev",
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    pagination={{ clickable: true }}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                >
                    {reviews.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="bg-white rounded-2xl shadow-md p-5 sm:p-6 hover:shadow-xl transition duration-300 h-full flex flex-col justify-between">

                                {/* Stars */}
                                <div className="flex justify-center mb-4 text-yellow-400 text-sm sm:text-base">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} />
                                    ))}
                                </div>

                                {/* Review */}
                                <p className="text-gray-600 text-sm sm:text-base mb-6 leading-relaxed">
                                    "{item.review}"
                                </p>

                                {/* User */}
                                <div className="flex items-center justify-center gap-3">
                                    <img
                                        src={item.image}
                                        alt={item.name}
                                        className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover"
                                    />
                                    <div className="text-left">
                                        <h4 className="text-sm sm:text-base font-semibold text-gray-800">
                                            {item.name}
                                        </h4>
                                        <p className="text-xs sm:text-sm text-gray-500">
                                            {item.role}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </section>
    );
}